import { CSSProperties } from '@material-ui/core/styles/withStyles';
import React from 'react';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import ErrorText from '../ErrorComponent/ErrorText';
import { Fall, Temp } from './Weather';

type WetherConditionsBoxProps = {
	dt: number;
	description: string;
	temp: number | Temp;
	pop?: number;
	rain?: number | Fall;
	snow?: number | Fall;
	showTime?: boolean;
};

const containerStyle: CSSProperties = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	color: '#3c4858',
	minWidth: '100px',
};
const rowStyle = { display: 'flex', justifyContent: 'space-between' };
const textRed700: CSSProperties = { color: '#ef4444', fontWeight: 700 };

export default function WeatherConditionsBox({ dt, description, temp, pop, rain, snow, showTime }: WetherConditionsBoxProps) {
	const fmtPop = pop ? Math.round(pop * 100) + '%' : '0%';
	const popHighlight = (pop: number | undefined) => {
		const threshold = 70;
		const popPercent = pop * 100;
		if (!pop) return null;
		if (popPercent >= threshold) return textRed700;
	};

	const fmtTemp = (temp: number | Temp) => {
		const fmtTmp = typeof temp === 'number' ? temp : temp?.day;
		return Math.round(fmtTmp as number);
	};

	const rainValue = typeof rain === "number"
		? rain
			? rain < 1
				? '<1'
				: Math.round(rain)
			: 0
		: 0;
	const snowValue = typeof snow === "number"
		? snow
			? snow < 1
				? '<1'
				: Math.round(snow)
			: 0
		: 0;
	try {
		return (
			<ErrorComponent Children message='Weather conditions cannot be rendered'>
				<div style={containerStyle}>
					<div style={rowStyle}>
						<div>temp: </div>
						<div>{fmtTemp(temp)}°C</div>
					</div>
					<div style={rowStyle}>
						<div>fall chance: </div>
						<div>
							<span style={popHighlight(pop)}>{fmtPop}</span>
						</div>
					</div>
					<div style={rowStyle}>
						<div>rain: </div>
						<div>{rainValue}mm</div>
					</div>
					<div style={rowStyle}>
						<div>snow: </div>
						<div>{snowValue}mm</div>
					</div>
				</div>
			</ErrorComponent>
		);
	} catch (error) {
		return <ErrorText message='Weather conditions cannot be rendered' />;
	}
}
